// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_chat__Chat_tool from "../../shared/chat/chat_tool.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function field(json, name) {
  return Stdlib__Option.bind(Js__Js_json.decodeObject(json), (function (fields) {
    return Js__Js_dict.get(fields, name);
  }));
}

function string(json, name) {
  return Stdlib__Option.bind(field(json, name), Js__Js_json.decodeString);
}

function bound(value) {
  if (value.length <= 2048) {
    return value;
  } else {
    return Stdlib__String.sub(value, 0, 2048) + "\xe2\x80\xa6";
  }
}

function rendered(json, name) {
  return Stdlib__Option.bind(field(json, name), (function (value) {
    if (Caml_obj.caml_equal(value, null)) {
      return;
    } else {
      return bound(JSON.stringify(value, null, 2));
    }
  }));
}

function result_content(json) {
  return Stdlib__Option.bind(Stdlib__Option.bind(field(json, "content"), Js__Js_json.decodeArray), (function (items) {
    const texts = Stdlib__List.filter_map((function (item) {
      return Stdlib__Option.bind(field(item, "content"), (function (content) {
        if (Caml_obj.caml_equal(string(content, "type"), "text")) {
          return string(content, "text");
        }
        
      }));
    }), Stdlib__Array.to_list(items));
    if (texts) {
      return bound(Stdlib__String.concat("\n", texts));
    }
    
  }));
}

function status(param) {
  switch (param) {
    case "completed" :
      return /* Completed */ 2;
    case "failed" :
      return /* Failed */ 3;
    case "in_progress" :
      return /* In_progress */ 1;
    case "pending" :
      return /* Pending */ 0;
    default:
      return /* Unknown */ 4;
  }
}

function decode(data) {
  const update = Stdlib__Option.bind(field(data, "params"), (function (p) {
    return field(p, "update");
  }));
  return Stdlib__Option.bind(update, (function (update) {
    const match = string(data, "method");
    const match$1 = string(update, "sessionUpdate");
    const match$2 = string(update, "toolCallId");
    if (match === undefined) {
      return;
    }
    if (match !== "session/update") {
      return;
    }
    if (match$1 === undefined) {
      return;
    }
    switch (match$1) {
      case "tool_call" :
      case "tool_call_update" :
        break;
      default:
        return;
    }
    if (match$2 === undefined) {
      return;
    }
    if (match$2 === "") {
      return;
    }
    const output = rendered(update, "rawOutput");
    return {
      id: match$2,
      title: Stdlib__Option.map(bound, string(update, "title")),
      status: Stdlib__Option.map(status, string(update, "status")),
      input: rendered(update, "rawInput"),
      output: output !== undefined ? output : result_content(update)
    };
  }));
}

const merge = Mapre_chat__Chat_tool.merge;

const title = Mapre_chat__Chat_tool.title;

const status_text = Mapre_chat__Chat_tool.status_text;

export {
  decode,
  merge,
  title,
  status_text,
}
/* No side effect */
